import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
const AutosaveIndicator = () => {
  const [saveStatus, setSaveStatus] = useState<'saved' | 'saving'>('saved');
  useEffect(() => {
    const handleChange = () => {
      setSaveStatus('saving');
      setTimeout(() => {
        setSaveStatus('saved');
      }, 1000);
    };
    window.addEventListener('input', handleChange);
    return () => {
      window.removeEventListener('input', handleChange);
    };
  }, []);
  return <div className="flex items-center text-sm" data-id="element-5" data-mp="mk0548wqybs9">
      {saveStatus === 'saved' ? <>
          <CheckCircleIcon size={16} className="text-green-500 mr-1.5" data-id="element-6" data-mp="raoyjtrzliu1" />
          <span className="text-slate-200" data-id="element-7" data-mp="rdkxnlfkmdk2">All changes saved</span>
        </> : <span className="text-slate-200" data-id="element-8" data-mp="wce814zk9og0">Saving...</span>}
    </div>;
};
export default AutosaveIndicator;